import cls from 'classnames';

import MediaPlaceholder from '@/media/components/MediaPlaceholder/MediaPlaceholder';
import PreviewImage from '@/media/components/PreviewImage/PreviewImage';
import { PreviewFragment } from '@/media/types/PreviewResponse';

import styles from './CollectionPreviewFragment.module.css';

export interface CollectionPreviewFragmentProps {
  fragment: PreviewFragment;
  size: number;
  isBordered: boolean;
  isRenderLabelExpandable: boolean;
}

function CollectionPreviewFragment(props: CollectionPreviewFragmentProps) {
  const { fragment, size, isBordered, isRenderLabelExpandable } = props;

  const imageClassName = cls(styles.image, { [styles.bordered]: isBordered });

  if (fragment.url) {
    return (
      <PreviewImage
        url={fragment.url}
        size={size}
        bg={fragment.bg}
        isRender={fragment.isRender}
        isRenderLabelExpandable={isRenderLabelExpandable}
        className={imageClassName}
      />
    );
  } else {
    return (
      <MediaPlaceholder
        shape={fragment.placeholder?.cutShapeId ?? fragment.placeholder?.type}
        size={isBordered ? size - 2 : size}
        className={imageClassName}
      />
    );
  }
}

export default CollectionPreviewFragment;
